module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/05-9b7e27eed72d94b4eb4a6ef519c05895.jpg";